import { TRANSLOCO_SCOPE } from '@ngneat/transloco';

export const LAYOUT_APP_TRANSLATION = {
  provide: TRANSLOCO_SCOPE,
  useValue: { scope: 'layout-app', alias: 'layoutApp' } // alias defaults to camelCase i.e. layoutApp
};

export const LAYOUT_BOOKING_TRANSLATION = {
  provide: TRANSLOCO_SCOPE,
  useValue: { scope: 'layout-app/booking', alias: 'booking' }
};

export const LAYOUT_ACCOUNT_TRANSLATION = {
  provide: TRANSLOCO_SCOPE,
  useValue: { scope: 'layout-app/account', alias: 'account' }
};

export const LAYOUT_REPORTS_TRANSLATION = {
  provide: TRANSLOCO_SCOPE,
  useValue: { scope: 'layout-app/reports', alias: 'reports' }
};
